export interface EstudianteActivoT{
    matricula: string;
    nombre: string;
    email: string;
    coddivision: string;
    codcarrera: string;
    codespecializ: string;
    pagoatiempo: string;
    codunidad: string;
    nombrecarrera: string;
    creditosregular: number;
    promedio: number; // decimal equivalente a number en TypeScript
    numaprobadas: number;
    estadocarrera: string;
    estadoacad: string;
    idpersona: number;
    egresado: boolean;
    duracioncarrera: number; // en años
    estudianteValido:MensajeEstudiante[] ,
}

export function VoidEstudianteActivo(): EstudianteActivoT{
    return {
        matricula: '',
        idpersona: 0,
        nombre: '',
        email: '',
        coddivision: '',
        codcarrera: '',
        codespecializ: '',
        pagoatiempo: '',
        codunidad: '',
        nombrecarrera: '',
        creditosregular: 0,
        promedio: 0,
        numaprobadas: 0,
        estadocarrera: '',
        estadoacad: '',
        egresado: false,
        duracioncarrera: 0,
        estudianteValido: []
    }
}

export function SetEstudianteActivo(data: any): EstudianteActivoT{
    return {
        matricula: data.matricula??'',
        idpersona: data.idpersona??0,
        nombre: data.nombre??'',
        email: data.email??'',
        coddivision: data.coddivision??'',
        codcarrera: data.codcarrera??'',
        codespecializ: data.codespecializ??'',
        pagoatiempo: data.pagoatiempo??'',
        codunidad: data.codunidad??'',
        nombrecarrera: data.nombrecarrera??'',
        creditosregular: data.creditosregular??0,
        promedio: data.promedio??0,
        numaprobadas: data.numaprobadas??0,
        estadocarrera: data.estadocarrera??'',
        estadoacad: data.estadoacad??'',
        egresado: data.egresado??false,
        duracioncarrera: data.duracioncarrera??0,
        estudianteValido: data.estudianteValido??[]
    }
}

export interface MensajeEstudiante{
    idtext_front: string | undefined;
    estado: boolean | undefined;
    mensaje: string | undefined;
}